import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {Link} from "../link/link";
import {WINNER_STATUSES} from "../../consts";
import {TOOLTIP_PLACEMENT} from "../tooltip/tooltip-consts";
import {Tooltip} from "../tooltip/tooltip";
import styles from "./live-score-badge.module.scss";
import classNames from "classnames";

export class LiveScoreBadgeProps extends BaseProps {
  className: String;
  routeProps: Object;
  tooltipContent: String;
  link: BaseLinkModel;
  winnerStatus: WINNER_STATUSES;
  onClick: Function;
  onMouseEnter: Function;
  onMouseLeave: Function;
}

export const LiveScoreBadge = (props: LiveScoreBadgeProps) => {
  const statusClassName: String = {
    [WINNER_STATUSES.win]: classNames(styles.win),
    [WINNER_STATUSES.draw]: classNames(styles.draw),
    [WINNER_STATUSES.lose]: classNames(styles.lose)
  };

  const className = classNames(props.className, styles.badge, statusClassName[props.winnerStatus]);

  const tooltipProps = {
    placement: TOOLTIP_PLACEMENT.bottom,
    content: props.tooltipContent,
    className
  };

  const linkProps = {
    model: props.link,
    routeProps: props.routeProps,
    onClick:() => props.onClick && props.onClick(),
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
  };

  return (
    <Link {...linkProps}>
      <Tooltip {...tooltipProps}>
        {props.children}
      </Tooltip>
    </Link>
  )
};